import { useSyncExternalStore } from 'react'
import { parseShareIdQuery, type ShareIdQuery } from '../utils/shareIdQuery'

const SHARE_ID_QUERY_EMPTY: ShareIdQuery = { isPresent: false, value: '' }

function subscribe(onChange: () => void) {
    window.addEventListener('popstate', onChange)
    window.addEventListener('hashchange', onChange)
    return () => {
        window.removeEventListener('popstate', onChange)
        window.removeEventListener('hashchange', onChange)
    }
}

function createShareIdQueryHook(paramName: string) {
    let cachedSearch = ''
    let cachedQuery: ShareIdQuery = SHARE_ID_QUERY_EMPTY

    function getSnapshot(): ShareIdQuery {
        const search = window.location.search
        if (search === cachedSearch) {
            return cachedQuery
        }
        cachedSearch = search
        const next = parseShareIdQuery(search, paramName)
        cachedQuery =
            !next.isPresent && next.value === ''
                ? SHARE_ID_QUERY_EMPTY
                : { isPresent: next.isPresent, value: next.value }
        return cachedQuery
    }

    function getServerSnapshot(): ShareIdQuery {
        return SHARE_ID_QUERY_EMPTY
    }

    return function useShareIdQuery(): ShareIdQuery {
        return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
    }
}

// Reads `cID` from the current URL and re-renders on navigation.
export const useCardIdQuery = createShareIdQueryHook('cID')

// Reads `characterID` from the current URL and re-renders on navigation.
export const useCharacterIdQuery = createShareIdQueryHook('characterID')
